import styled, { css, keyframes } from 'styled-components';
import { Card as BaseCard, Layout as BaseLayout, Space as BaseSpace, Typography } from 'antd';
import * as color from 'modules/common/theme/color';
import { CheckOutlined as BaseCheck } from '@ant-design/icons/lib/icons';
import { PrimaryButton } from '../../../common/components';

interface ShakeProps {
  shaking?: boolean;
}

const Card = styled(BaseCard)`
  box-shadow: rgba(0, 0, 0, 0.16) 0 3px 6px;
  background: ${color.PlusPlanReviewAndPayBackground};

  .ant-card-body {
    padding: 0 !important;
  }
`;

const SummarySection = styled.div`
  padding: 20px;
  background-color: ${color.TableHeader};
`;

const MainLayout = styled(BaseLayout)`
  padding: 30px;
  background: ${color.PlusPlanReviewAndPayBackground};

  @media (max-width: 576px) {
    padding: 10px;
  }
`;

const Section = styled.div`
  padding-top: 20px;
`;

const PlanDetailsSection = styled.div`
  padding: 10px;
  background-color: ${color.White};
`;

const PlanTitleSection = styled(BaseSpace)`
  justify-content: space-between;
  width: 100%;
`;

const PlanTitle = styled(Typography.Text)`
  font-size: 16px !important;
`;

const EditLink = styled.div`
  font-size: 14px;
  color: ${color.PhoneLink};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const PlanDetails = styled.div`
  margin-top: 5px;
`;

const PlanDetailItem = styled(Typography.Text)`
  display: block;
`;

const TotalPaymentSection = styled.div`
  margin-top: 20px;
`;

const TotalPayment = styled.div`
  text-align: right;
`;

const PayNowButton = styled(PrimaryButton)`
  width: 100% !important;
  margin-bottom: 20px !important;

  &:disabled {
    background: ${color.PrimaryButtonHover} !important;
    color: ${color.White} !important;
  }
`;

const shakeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
`;

const ShakeDiv = styled.div<ShakeProps>`
  cursor: pointer;
  ${({ shaking }) =>
    shaking &&
    css`
      animation: ${shakeAnimation} 0.5s;
    `}
`;

const CheckOutlined = styled(BaseCheck)`
  font-size: 16px;
  color: green;
  font-weight: bolder;
`;

const ModalDescription = styled.span`
  font-size: 18px;

  b {
    font-weight: 700;
    color: ${color.PrimaryColor};
    margin-right: 2px;
  }
`;

export default {
  Card,
  MainLayout,
  Section,
  SummarySection,
  PlanDetailsSection,
  PlanTitleSection,
  PlanTitle,
  EditLink,
  PlanDetails,
  PlanDetailItem,
  TotalPaymentSection,
  TotalPayment,
  PayNowButton,
  ShakeDiv,
  CheckOutlined,
  ModalDescription,
};
